import './App.css'
import { APP_ROUTES } from "@/constants";
import {HashRouter, Route, Routes} from "react-router-dom";
import { lazy, Suspense } from "react";

const Home = lazy(() => import("@/pages/Home.tsx"));
const AdminPodcasts = lazy(() => import("@/pages/AdminPodcasts.tsx"));
const SoftwarePeopleStories = lazy(() => import("@/pages/SoftwarePeopleStories.tsx"));
const PodcastList = lazy(() => import("@/pages/PodcastList.tsx"));

function App() {
  return (
    <HashRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path={APP_ROUTES.home} element={<Home />} />
          <Route path={APP_ROUTES.adminPodcasts} element={<AdminPodcasts />} />
          <Route path={APP_ROUTES.stories} element={<SoftwarePeopleStories />} />
          <Route path={APP_ROUTES.sps} element={<SoftwarePeopleStories />} />
          <Route path={APP_ROUTES.podcastList} element={<PodcastList />} />
          <Route path={APP_ROUTES.podcast2} element={<PodcastList />} />
        </Routes>
      </Suspense>
    </HashRouter>
  )
}

export default App
